<template>
  <div id="addEditDomain">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/countries" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 pa-0">
            <h5 class="pf-sub-head mb-3 mt-4 custom-title">
              <b>Select Family</b>
            </h5>
          </v-flex>
          <v-flex sm6 class="pr-2 pa-0">
            <v-autocomplete
              v-model="selectedAccount" 
              @change="selectedFamily" 
              @keyup.enter="searchFamilies($event)" 
              :items="familyList"
              item-text="text"
              item-value="id"
              return-object
              label="Select the family (Featured or Preferred)"
              id="accountSearch"
              placeholder="Search by Name / Nickname / PPN"
              hint="Type atleast 3 characters to search, PPN should be entered completely"
              persistent-hint
              no-data-text="No data available, please search by family"
              class="required">
              <v-icon slot="append" @click="searchFamilies($event)"> search </v-icon>
            </v-autocomplete>
          </v-flex>
          <v-layout class="domainWrapper mt-4" v-show="accountSelected && selectedAccount.id">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Choose Domain</b>
              </h5>
            </v-flex>
            <v-flex class="xs12 sm4 pr-2">
              <v-text-field label="Subdomain" ref="subdomain" :append-icon="`${ parentDomain.disabled ? 'edit' : '' }`" :readonly="parentDomain.disabled" :error="!parentDomain.valid && parentDomain.invalidText !== ''" v-model="parentDomain.name" @input="parentDomain.invalidText = ''; parentDomain.valid = false" @click:append="enableEdit" suffix="-"
              ></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm4 pr-2">
              <v-select
                v-model="parentDomain.suffix"
                :items="[...config.parentDomain.suffix, ...['None']]"
                label="Suffix"
                @input="suffixChanged"
                :disabled="parentDomain.disabled"
              ></v-select>
            </v-flex>
            <v-flex class="xs12 sm4 pr-4">
              <h4 class="parent-domain">.{{config.parentDomain.domainName }}</h4>
            </v-flex>
            <v-flex class="xs12 pr-4" v-if="parentDomain.name && parentDomain.suffix">

              <p v-if="!parentDomain.valid && parentDomain.invalidText !== ''" class="pf-text-red">{{ parentDomain.invalidText }}</p>

              <p v-else-if="parentDomain.valid && parentDomain.invalidText === ''" class="pf-text-green">Selected domain is available, you can create it now</p>

              <p v-if="!parentDomain.disabled"><strong>Selected domain:</strong> <a target="_blank" :href="`https://${getSelectedDomain}`">{{ getSelectedDomain }}</a></p>

              <p v-if="selectedAccount.contactInfo && selectedAccount.contactInfo.website"><strong>Registered domain:</strong> <a target="_blank" :href="`${ selectedAccount.contactInfo.website.indexOf('http') > -1 ? selectedAccount.contactInfo.website : ('https://' + selectedAccount.contactInfo.website) }`">{{ selectedAccount.contactInfo.website.indexOf('http') > -1 ? selectedAccount.contactInfo.website : ('https://' + selectedAccount.contactInfo.website) }}</a></p>

            </v-flex>
            <v-flex class="xs12 pr-4" v-if="parentDomain.name && parentDomain.suffix && !parentDomain.disabled">
              <v-btn class="pf-btn pf-bg-teal ml-0" @click="checkParentDomain" v-if="!parentDomain.valid">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Check Domain</div>
              </v-btn>
              <v-btn class="pf-btn pf-bg-teal ml-0" @click="createParentDomain" v-else>
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Create Domain</div>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout class="domainWrapper mt-4" v-show="accountSelected && selectedAccount.id">
            <v-flex class="xs12">
              <h5 class="pf-sub-head mb-3 mt-4 custom-title">
                <b>Meta Keywords</b>
              </h5>
            </v-flex>
            <v-flex xs12 md7>
              <v-combobox class="hide_dropdown_icon" :rules="[]" @change="changedKeywords = true" v-model="selectedAccount.meta_keywords" label="Meta keywords" hint="keywords - hit enter to add keyword" multiple deletable-chips small-chips></v-combobox>
            </v-flex>
            <v-btn class="pf-btn pf-bg-teal ml-0" @click="saveKeywords" v-if="changedKeywords">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/countries" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
import { request, update, create, getCollection } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';

// To add new countries by the admin
export default {
  name: 'AddCountry',
  data: () => ({
    config: config,
    newCountry: {
      name: '',
      code: ''
    },
    loading: false,
    selectedData: false,
    accountSelected: false,
    rules: {
      required: value => !!value.trim() || 'Field is required.',
      onlyTwoLetters: value => (value.trim().length === 2 && /^[a-zA-Z]+$/.test(value.trim())) || 'Country code must have two letters.'
    },
    query: {
      family: ''
    },
    selectedAccount: {},
    familyList: [],
    parentDomain: {
      name: '',
      suffix: 'adopt',
      valid: false,
      disabled: false,
      invalidText: ''
    },
    changedKeywords: false
  }),
  computed: {
    ClientDomains: {
      set (value) {
        store.commit('setClientDomains', value);
      },
      get () {
        return store.state.ClientDomains;
      }
    },
    getSelectedDomain () {
      return `${this.parentDomain.name}${this.parentDomain.suffix !== 'None' ? ('-' + this.parentDomain.suffix) : ''}.${config.parentDomain.domainName}`;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    if (this.$route.params.family) {
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.selectedAccount = this.$route.params.family;
      this.familyList.push(this.selectedAccount);
      this.selectedFamily();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', this.$route.params.family ? 'Edit' : 'Add');
  },
  methods: {
    // @vuese
    // Used to search for families on entering nickname, PPN or the status
    // @arg The type of search - family or status
    async searchFamilies (e) {
      this.familyList = [];
      this.selectedAccount = {};
      this.query.family = e.target.value ? e.target.value : document.querySelector('input[id="accountSearch"]').value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { };
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        /* Consider only non Network members */
        where.membership = { '$exists': true, '$ne': 'Network' };
        let attributes = 'profile_number,profile_year,contactInfo.website,name,nickname,meta_keywords,status,account_type';
        let sort = { 'createdAt': -1 };

        let { error, data } = await getCollection('Account', true, 0, '', where, attributes, null, sort);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load the family list'
          };
        } else {
          if (data.length > 0) {
            this.familyList = this.formatFamilyList(data);
          }
        }
      }
    },
    formatFamilyList (data) {
      let list = [];
      if (data.length) {
        data.forEach(row => {
          let entry = row;
          entry.text = row.name;
          if (row.nickname.toLowerCase().includes(document.querySelector('input[id="accountSearch"]').value.toLowerCase())) {
            entry.text = row.nickname;
          } else {
            entry.text = row.ppn === document.querySelector('input[id="accountSearch"]').value ? `${row.ppn} / ${row.name}` : entry.text;
            
          }
          list.push(entry);
        });
      }
      return list;
    },
    async checkParentDomain () {
      if (this.parentDomain.name && this.parentDomain.suffix) {
        let payload = {
          record: this.parentDomain.name + (this.parentDomain.suffix !== 'None' ? ('-' + this.parentDomain.suffix) : '')
        };
        let { error, data } = await request('Cloudflare/CheckDNS', 'POST', payload);
        const alreadyExists = error && error.indexOf('already exists') > -1;
        if (error && !alreadyExists) {
          console.log(error);
        } else {
          if (!alreadyExists) {
            this.parentDomain.valid = true;
          } else {
            this.parentDomain.valid = false;
            this.parentDomain.invalidText = 'The selected domain is not available, please choose another or try changing the suffix.';            
          }
        }
      }
    },
    async createParentDomain () {
      if (this.selectedAccount.id && this.parentDomain.name && this.parentDomain.suffix) {
        let payload = {
          account: this.selectedAccount.id,
          type: config.parentDomain.type,
          name: this.parentDomain.name + (this.parentDomain.suffix !== 'None' ? ('-' + this.parentDomain.suffix) : ''),
          ttl: config.parentDomain.ttl
        };
        let { error, data, status } = await create('Cloudflare', payload);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Unable to create the subdomain, please try again.'
          };
        } else {
          // Update the state account
          if (this.selectedAccount.contactInfo) {
            this.selectedAccount.contactInfo.website = data.contactInfo.website;
          } else {
            this.selectedAccount.contactInfo = { website: data.contactInfo.website };
          }
          this.parentDomain.valid = false;
          this.parentDomain.disabled = true;
          let existIndex = this.ClientDomains.findIndex(x => x.nickname === this.selectedAccount.nickname);
          if (existIndex > -1) {
            this.ClientDomains[existIndex].contactInfo.website = data.contactInfo.website;
          } else {
            this.ClientDomains.unshift(this.selectedAccount);
          }
          swal.fire({
            type: 'success',
            title: 'Success',
            text: 'The subdomain created successfully, it can take maximum of 10 minutes to be live',
            showConfirmButton: false,
            timer: 3500,
            onClose: () => {
              this.backToListing();
            }
          });
        }
      }
    },
    changedData () {
      // this.selectedData = true;
    },
    saveKeywords () {
      if (this.changedKeywords) {
        let payload = {
          ...this.selectedAccount,
          meta_keywords: this.selectedAccount.meta_keywords,
          updated_from: 'websiteTemplate'
        };
        const { error, data } = update('Account', payload, this.selectedAccount.id);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to save the meta keywords'
          };
        } else {
          this.changedKeywords = false;
          swal.fire({
            type: 'success',
            title: 'Success',
            text: 'The meta keywords saved successfully',
            showConfirmButton: false,
            timer: 3500
          });
        }
      }
    },
    selectedFamily () {
      this.accountSelected = true;
      this.setWebsite();
    },
    setWebsite () {

      if (this.selectedAccount.contactInfo && this.selectedAccount.contactInfo.website) {

        let uri = this.selectedAccount.contactInfo.website.replace('http://', '').replace('https://', '').replace('www.', '');
        let sDomain = [];
        if (uri.indexOf(config.parentDomain.domainName) > -1) {
          sDomain = uri.split('.' + config.parentDomain.domainName);
        } else {
          sDomain = uri.split('.com');
        }
        // Handle the case when there's no suffix (hence no -)
        if (sDomain[0].indexOf('-') === -1) {
          this.parentDomain.name = sDomain[0];
          this.parentDomain.suffix = 'None';
          this.parentDomain.disabled = true;
          return;
        }
        let sname = sDomain[0].split('-');
        let suffixIndex = config.parentDomain.suffix.indexOf(sname[1]);
        this.parentDomain.name = suffixIndex > -1 ? sname[0] : '';
        this.parentDomain.suffix = suffixIndex > -1 ? sname[1] : 'adopt';
        this.parentDomain.disabled = true;
      } else {
        this.parentDomain.name = this.selectedAccount.nickname ? this.selectedAccount.nickname : '';
        this.parentDomain.suffix = 'adopt';
        this.parentDomain.disabled = false;
        this.$refs.subdomain.focus();
      }
    },
    enableEdit () {
      this.parentDomain.disabled = false;
      this.$refs.subdomain.focus();
      this.parentDomain.invalidText = '';
      this.parentDomain.valid = false;
    },
    suffixChanged () {
      this.parentDomain.disabled = false;
      this.$refs.subdomain.focus();
      this.parentDomain.invalidText = '';
      this.parentDomain.valid = false;
    },
    // @vuese
    // Used to go back to the country listing page
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ name: 'ClientDomains' });
    }
  }
};
</script>

<style scoped>

.domainWrapper {
  display: contents;
}
.parent-domain {
  display: flex;
  align-items: center;
}
#addEditDomain >>> .hide_dropdown_icon .v-input__append-inner {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/pages/ClientDomains/add.vue